import React from 'react';
import Box from '@mui/material/Box';
import {
  OrganizationsFooter,
  OrganizationsGrid,
  OrganizationsHeader,
  OrganizationsTable,
  OrganizationsToolbar,
  StatsCards,
} from './components';
import { useOrganizationsPage } from './hooks';

export const Organizations: React.FC = () => {
  const page = useOrganizationsPage();

  return (
    <Box sx={{ p: { xs: 2, sm: 4 }, bgcolor: 'background.default', minHeight: '100vh' }}>
      <Box sx={{ maxWidth: 1600, mx: 'auto' }}>
        <OrganizationsHeader
          viewMode={page.viewMode}
          onViewModeChange={page.setViewMode}
          onSearch={page.setSearchQuery}
          onFiltersChange={page.handleFiltersChange}
          onCreate={page.handleCreate}
        />

        <StatsCards
          activeUsers={page.organizationSubscriptions.activeUsers}
          totalOrganizations={page.organizationSubscriptions.totalOrganizations}
        />

        <OrganizationsToolbar
          sortKey={page.sortKey}
          onSortChange={page.setSortKey}
        />

        <Box sx={{ transition: 'all 0.5s ease-in-out' }}>
          {page.viewMode === 'table' ? (
            <OrganizationsTable
              rows={page.organizationRows}
              onEdit={page.handleEdit}
              onDelete={page.handleDelete}
              onView={page.handleRowClick}
              onRowClick={page.handleRowClick}
            />
          ) : (
            <OrganizationsGrid
              data={page.organizationSubscriptions.data}
              onCardClick={page.handleOrgClick}
              onQuickAdd={page.handleCreate}
            />
          )}
        </Box>

        <OrganizationsFooter
          viewMode={page.viewMode}
          visibleCount={page.organizationSubscriptions.data.length}
          totalCount={page.organizationSubscriptions.total}
          onPrevPage={page.handlePrevPage}
          onNextPage={page.handleNextPage}
        />
      </Box>
    </Box>
  );
};

export default Organizations;
